export enum WorkType {
  CONTROL_ACCEPTANCE = 'CONTROL_ACCEPTANCE',
}
